import type { IWalletMetadata } from '../types.js'

export const wallets: IWalletMetadata[] = [
  {
    "id": "alfa1",
    "filePath": "wallet:alfa1",
    "name": "alfa1",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "alpha-wallet",
    "filePath": "wallet:alpha-wallet",
    "name": "alpha wallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "argent",
    "filePath": "wallet:argent",
    "name": "argent x",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "backpack",
    "filePath": "wallet:backpack",
    "name": "backpack",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "clave",
    "filePath": "wallet:clave",
    "name": "clave",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coin98",
    "filePath": "wallet:coin98",
    "name": "coin98",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinbase",
    "filePath": "wallet:coinbase",
    "name": "coinbase wallet",
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "enkrypt",
    "filePath": "wallet:enkrypt",
    "name": "enkrypt",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "imtoken",
    "filePath": "wallet:imtoken",
    "name": "imToken",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kraken",
    "filePath": "wallet:kraken",
    "name": "kraken wallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ledger",
    "filePath": "wallet:ledger",
    "name": "ledger",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "lit",
    "filePath": "wallet:lit",
    "name": "lit protocol",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "metamask",
    "filePath": "wallet:metamask",
    "name": "MetaMask",
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "multis",
    "filePath": "wallet:multis",
    "name": "multis",
    "variants": [
      "mono",
      "background"
    ]
  },
  {
    "id": "my-ether-wallet",
    "filePath": "wallet:my-ether-wallet",
    "name": "MyEtherWallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "obvious",
    "filePath": "wallet:obvious",
    "name": "obvious wallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "okx",
    "filePath": "wallet:okx",
    "name": "okx wallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "phantom",
    "filePath": "wallet:phantom",
    "name": "phantom",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pillar",
    "filePath": "wallet:pillar",
    "name": "Pillar",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "portal",
    "filePath": "wallet:portal",
    "name": "portal",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rabby",
    "filePath": "wallet:rabby",
    "name": "rabby",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "rainbow",
    "filePath": "wallet:rainbow",
    "name": "rainbow",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "ronin",
    "filePath": "wallet:ronin",
    "name": "ronin",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "safe",
    "filePath": "wallet:safe",
    "name": "safe wallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sender",
    "filePath": "wallet:sender",
    "name": "sender",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sequence",
    "filePath": "wallet:sequence",
    "name": "sequence",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "soul",
    "filePath": "wallet:soul",
    "name": "soul",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "squads",
    "filePath": "wallet:squads",
    "name": "squads",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "token-pocket",
    "filePath": "wallet:token-pocket",
    "name": "token pocket",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trezor",
    "filePath": "wallet:trezor",
    "name": "trezor",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "trust",
    "filePath": "wallet:trust",
    "name": "trust wallet",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "unipass",
    "filePath": "wallet:unipass",
    "name": "unipass",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "venly",
    "filePath": "wallet:venly",
    "name": "venly",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wallet-3",
    "filePath": "wallet:wallet-3",
    "name": "wallet3",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "wallet-connect",
    "filePath": "wallet:wallet-connect",
    "name": "wallet connect",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "xdefi",
    "filePath": "wallet:xdefi",
    "name": "xdefi",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zengo",
    "filePath": "wallet:zengo",
    "name": "zengo",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "zerion",
    "filePath": "wallet:zerion",
    "name": "zerion",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "atomic",
    "filePath": "wallet:atomic",
    "name": "Atomic",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bitbox",
    "filePath": "wallet:bitbox",
    "name": "Bitbox",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "blue",
    "filePath": "wallet:blue",
    "name": "Blue Wallet",
    "variants": [
      "background",
      "branded"
    ]
  },
  {
    "id": "exodus",
    "filePath": "wallet:exodus",
    "name": "Exodus",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "glow",
    "filePath": "wallet:glow",
    "name": "Glow",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "keplr",
    "filePath": "wallet:keplr",
    "name": "Keplr",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kukai",
    "filePath": "wallet:kukai",
    "name": "Kukai",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "solflare",
    "filePath": "wallet:solflare",
    "name": "Solflare",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "temple",
    "filePath": "wallet:temple",
    "name": "Temple",
    "variants": [
      "background",
      "branded"
    ]
  },
  {
    "id": "pecunity-wallet",
    "filePath": "token:PEC",
    "name": "Pecunity",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ambire",
    "filePath": "token:WALLET",
    "name": "Ambire",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cypherock",
    "filePath": "wallet:cypherock",
    "name": "Cypherock",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "daimo",
    "filePath": "wallet:daimo",
    "name": "Daimo Pay",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  }
]